export default {
  featuredExperiences: 'ประสบการณ์แนะนำของเรา',
  searchAllExperiences: 'ค้นหาประสบการณ์ทั้งหมด',
  searchAll: 'ค้นหาทั้งหมด',
  groupSize: 'ขนาดกลุ่ม',
  eventSize: 'ขนาดงาน',
  upTo: 'สูงสุด',
  whatWeDo: 'สิ่งที่เราจะทำ',
  hostedBy: 'จัดโดย',
  whatsIncluded: 'สิ่งที่รวมอยู่',
  avail: 'จำนวนที่ว่าง',
  whereWeAre: 'สถานที่จัดกิจกรรม',
  experienceCalendar: 'ปฏิทินประสบการณ์',
  experienceCancelled: 'ประสบการณ์ถูกยกเลิก',
  experienceStartingPrice: 'เริ่มต้น {{price}}',
  experienceTotalPrice: 'รวม {{price}}',
  at: 'เวลา',
  viewPrivateSessAvailability: 'ดูรอบส่วนตัวที่ว่าง',
  selectDuration: 'ระยะเวลา',
  selectStartTime: 'เวลาเริ่มต้น',
  selectSession: 'เลือกรอบ',
  sessionsCount: '{{count}} เวลา — เลือกเวลา',
  noAvailability: 'ไม่มีรอบว่าง',
  select: 'เลือก',
  slotLeft: 'เหลืออีก {{remainSlots}} ที่',
  slotsLeft: 'เหลืออีก {{remainSlots}} ที่',
  spotsLeft: 'เหลือ {{count}}',
  spotsLeftAriaLabel: 'เหลือ {{count}} ที่',
  bookExperience: 'จองประสบการณ์',
  book: 'จอง',
  learnMore: 'เรียนรู้เพิ่มเติม',
  apply: 'ใช้',
  maxPartySizes: 'สูงสุด {{maxGroupSize}} ที่ต่อกลุ่ม',
  maxPartySize: 'สูงสุด {{maxGroupSize}} ที่ต่อกลุ่ม',
  selectSessionValidation: 'กรุณาเลือกรอบ',
  selectParticipantValidation: 'กรุณาเลือกผู้เข้าร่วม',
  selectDateValidation: 'กรุณาเลือกวันที่',
  reminders: 'การแจ้งเตือน',
  seeOtherDates: 'ดูวันอื่น',
  location: 'สถานที่',
  about: 'เกี่ยวกับ',
  allExperiences: 'ประสบการณ์ทั้งหมด',
  soldOut: 'ขายหมดแล้ว',
  addOns: 'ส่วนเสริม',
  reviews: 'รีวิว',
  reviewSingular: 'รีวิว',
  reviewPlural: 'รีวิว',
  dateOfExperience: 'วันที่ของประสบการณ์',
  readLess: 'อ่านน้อยลง',
  readMore: 'อ่านเพิ่มเติม',
  seeMore: 'ดูเพิ่มเติม',
  details: 'รายละเอียด',
  durationHour: 'ชั่วโมง',
  durationHours: 'ชั่วโมง',
  durationMinutes: 'นาที',
  theFollowingVideoDoesNotContainAnyAudio: 'วิดีโอต่อไปนี้ไม่มีเสียง',
  by: 'โดย',
  chooseATime: 'เลือกเวลาสำหรับ {{title}}',
  amenities: 'สิ่งอำนวยความสะดวก',
  ticketSalesOpenIn: 'ตั๋วเปิดจำหน่ายในอีก',
  ticketSalesOpen: 'ตั๋วเปิดจำหน่าย',
  ticketSalesCloseIn: 'ตั๋วปิดจำหน่ายในอีก',
  ticketSalesClose: 'ตั๋วปิดจำหน่าย',
  ticketSalesClosed: 'ตั๋วปิดจำหน่ายแล้ว',
  comingSoon: 'เร็ว ๆ นี้',
  inPartnershipWith: 'ร่วมมือกับ',
  notFoundExperienceTitle: 'ประสบการณ์นี้ไม่มีให้บริการอีกต่อไป',
  notFoundExperienceSubtitle:
    'อาจถูกยกเลิกการเผยแพร่ หรือลิงก์อาจใช้ไม่ได้อีกต่อไป',
  deadLinkRecoverySubtitle: 'ค้นพบประสบการณ์อื่นๆ ที่สามารถจองได้',
  viewAllExperiences: 'ดูประสบการณ์ทั้งหมด',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>รับ 5 คะแนนพื้นฐาน</strong> ต่อทุก $1 USD ที่มีสิทธิ์ เมื่อเข้าสู่ระบบบัญชี World of Hyatt ของคุณเพื่อจองประสบการณ์นี้</p>',
      basePoints:
        '<p><strong>รับ 10 คะแนนพื้นฐาน</strong> ต่อทุก $1 USD ที่มีสิทธิ์ เมื่อเข้าสู่ระบบบัญชี World of Hyatt ของคุณเพื่อจองประสบการณ์นี้</p>',
      additionalBonusPoints:
        '<p><strong>รับคะแนนโบนัสเพิ่มเติม 4 คะแนน</strong> ต่อทุก $1 USD ที่มีสิทธิ์ เมื่อจองด้วยบัตรเครดิต World of Hyatt ของคุณ</p>',
      additionalBonusPointsTier:
        '<p><strong>รับคะแนนโบนัสเพิ่มเติมสูงสุด 30%</strong> ขึ้นอยู่กับระดับสมาชิกของคุณ</p>',
      payWithPoints:
        '<p><strong>ชำระด้วยคะแนน</strong> เมื่อจองประสบการณ์นี้</p>',
    },
  },
};
